import { ReactComponent as IconChevron } from "@/assets/svgs/chevron-down-small.svg";
import { ReactComponent as IconSearch } from "@/assets/svgs/icon-search.svg";
import { ReactComponent as IconRadioSelected } from "@/assets/svgs/radio-selected.svg";
import { ReactComponent as IconRadioUnselected } from "@/assets/svgs/radio-unselected.svg";
import { ReactComponent as IconVeridaptActivity } from "@/assets/svgs/veridapt-activity-outline-medium.svg";
import { ReactComponent as IconVeridaptMilestones } from "@/assets/svgs/veridapt-milestone-flag-outline-medium.svg";
import { ReactComponent as IconVeridaptPackage } from "@/assets/svgs/veridapt-package-outline-medium.svg";
import InputSuffixIcon from "@/components/InputSuffixIcon";
import Popover from "@/components/Popover";
import classname from "classnames";
import { useEffect, useRef, useState } from "react";
import MultiClamp from "react-multi-clamp";
import usePackages from "@/hooks/use-packages/index.js";
import { feature, features } from '@/utils/feature-verifier';
import Search from '@/componentsDS/Search/index';

const SingleSelectDropdown = ({
	placeholder,
	selectionList,
	selectedItem,
	handleSelectionClick,
	disable,
	filterSearch,
	prefix,
	veridaptPrefix = false,
}) => {
	const [isvisible, setIsVisible] = useState(false);
	const [filterValue, setFilterValue] = useState("");

	const { NODE_TYPE } = usePackages();

	const popoverTriggerRef = useRef(null);
	const poppverContentRef = useRef(null);

	const sameRefWidth = {
		name: "sameRefWidth",
		enabled: true,
		phase: "beforeWrite",
		requires: ["computeStyles"],
		fn: ({ state }) => {
			state.styles.popper.width = `${state.rects.reference.width}px`;
		},
		effect: ({ state }) => {
			state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
		},
	};

	const singleSelectDropdownClass = classname({
		"single-select-dropdown__container": true,
		"single-select-dropdown__container--active": isvisible && !disable,
		"single-select-dropdown__container--inactive": !isvisible && !disable,
		"single-select-dropdown__container--disable": disable,
	});

	useEffect(() => {
		document.addEventListener("mousedown", handleDocumentClick);
		return () => {
			document.removeEventListener("mousedown", handleDocumentClick);
		};
	}, []);

	function handleDocumentClick(event) {
		if (
			popoverTriggerRef.current?.contains(event.target) ||
			poppverContentRef.current?.contains(event.target)
		) {
			return;
		}
		setIsVisible(false);
		setFilterValue("");
	}

	function handleSingleDropdownClick() {
		if (disable) {
			return;
		}
		setIsVisible(true);
		setFilterValue("");
	}

	function handleSingleItemSelect(option) {
		setIsVisible(false);
		handleSelectionClick(option);
	}

	return (
		<div className="single-select-dropdown-wrapper">
			<Popover
				visible={isvisible}
				options={{
					modifiers: [
						{ name: "offset", options: { offset: [0, 5] } },
						sameRefWidth,
					],
				}}
			>
				<Popover.Trigger>
					<div
						className={singleSelectDropdownClass}
						ref={popoverTriggerRef}
						onClick={handleSingleDropdownClick}
					>
						<>
							<div className="single-select-dropdown__text">
								{selectedItem?.name ? (
									<div className="single-select-dropdown__selection-text">
										<MultiClamp clamp={1}>
											{selectedItem.name}
										</MultiClamp>
									</div>
								) : (
									<div
										className={`${
											disable
												? "single-select-dropdown__disable-text"
												: "single-select-dropdown__placeholder-text"
										}`}
									>
										{placeholder}
									</div>
								)}
							</div>
							<div className="single-select-dropdown__icon">
								<IconChevron />
							</div>
						</>
					</div>
				</Popover.Trigger>

				<Popover.Content>
					<div
						className="single-select-dropdown__selection-container"
						ref={poppverContentRef}
					>
						{filterSearch && (
							<div className="single-select-dropdown__searchbox">
								<Search
									value={filterValue}
									placeholder='Search'
									onChange={(e) => setFilterValue(e?.target.value)}
									onCancel={() => setFilterValue('')}
									variant='filled'
								/>
							</div>
						)}

						<div className="single-select-dropdown__wrapper">
							{selectionList
								?.filter((item) =>
									item.name?.toLowerCase().includes(filterValue.toLowerCase())
								)
								.map((option) => (
									<div
										key={option.id}
										className={`single-select-dropdown__selection-item ${
											selectedItem.id === option.id
												? "single-select-dropdown__selected-item"
												: ""
										}`}
										onClick={() =>
											handleSingleItemSelect(option)
										}
									>
										<div className="single-select__container">
											<div
												className="single-select__radio-btn"
												data-testid="single-select-radio-btn"
											>
												{selectedItem.id ===
												option.id ? (
													<IconRadioSelected />
												) : (
													<IconRadioUnselected />
												)}
											</div>
											<div className="single-select__item">
												{prefix && (
													<div className="single-select__item-prefix">
														{prefix}
													</div>
												)}

												{veridaptPrefix && (
													<div className="single-select__item-prefix">
														{option.placementType ===
															NODE_TYPE.package && (
															<IconVeridaptPackage />
														)}
														{option.placementType ===
															NODE_TYPE.milestone && (
															<IconVeridaptMilestones />
														)}
														{option.placementType ===
															NODE_TYPE.activity && (
															<IconVeridaptActivity />
														)}
													</div>
												)}
												<div
													className={`single-select__item-name ${
														selectedItem.id ===
														option.id
															? "single-select__item-name--active"
															: ""
													}`}
												>
													<MultiClamp clamp={2}>
														{option.name}
													</MultiClamp>
												</div>
											</div>
										</div>
									</div>
								))}
						</div>
					</div>
				</Popover.Content>
			</Popover>
		</div>
	);
};

export default SingleSelectDropdown;
